import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]
  static values = { tipId: Number }
  
  connect() {
    if (this.shouldShowModal()) {
      this.showModal()
    }
  }
  
  disconnect() {
    // Clean up Bootstrap modal on disconnect
    const modal = bootstrap.Modal.getInstance(this.element)
    if (modal) {
      modal.dispose()
    }
  }
  
  dismiss() {
    // Store dismissal in session via AJAX
    const csrfToken = document.querySelector('[name="csrf-token"]')?.content
    
    fetch('/tip_dismissals', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken || ''
      },
      body: JSON.stringify({ tip_id: this.tipIdValue })
    }).catch(error => {
      // Log error but don't prevent modal from closing
      console.warn('Failed to store tip dismissal:', error)
    })
    
    this.hideModal()
  }
  
  shouldShowModal() {
    // Additional client-side check (optional)
    const today = new Date().toISOString().split('T')[0]
    const dismissedToday = localStorage.getItem(`tip_dismissed_${today}`)
    return !dismissedToday
  }
  
  showModal() {
    const modal = new bootstrap.Modal(this.element)
    modal.show()
  }
  
  hideModal() {
    const modal = bootstrap.Modal.getInstance(this.element)
    if (modal) {
      // Remove focus from any element inside the modal before hiding
      const activeElement = document.activeElement
      if (this.element.contains(activeElement)) {
        activeElement.blur()
      }
      
      modal.hide()
    }
    
    // Optional: Store client-side to prevent flash on page reload
    const today = new Date().toISOString().split('T')[0]
    localStorage.setItem(`tip_dismissed_${today}`, 'true')
  }
}
